import {
  ChangeSelectedNotificationsStatus,
  NotificationResultType,
} from 'src/app/services/notifications/notifications-service.type';
import { NotificationReadStatusEnum, NotificationStarStatusEnum } from 'src/enums/notifications.enum';

export type NotificationListType = 'Inbox' | 'Archived';

export const defaultPageSize = 20;
export const headerPageSize = 8;

export type FilterType = {
  labelIds: string[];
  readStatus: NotificationReadStatusEnum | undefined;
  starStatus: NotificationStarStatusEnum | undefined;
  priorities: string[];
  filteredNotificationCount: number;
};

export type NotificationStatusType = 'read' | 'archive' | 'relevant' | 'star';

export const changeStatusNotification = (
  type: NotificationStatusType | string,
  id: string,
  notification: NotificationResultType,
) => {
  const formData: ChangeSelectedNotificationsStatus = {
    ...notification,
    ids: [notification.id],
  };
  switch (type) {
    case 'read':
      formData.readStatus = Number(!notification.readStatus);
      break;
    case 'archive':
      formData.archiveStatus = Number(!notification.archiveStatus);
      break;
    case 'relevant':
      formData.relevantStatus = Number(!notification.relevantStatus);
      if (Number(!notification.relevantStatus) === 0) formData.readStatus = 1;
      break;
    case 'star':
      formData.starStatus = Number(!notification.starStatus);
      break;
    default:
      break;
  }
  return formData;
};
